import { roundQuantity } from './round-quantity.js';
/** True when the value is whole at the Decimal(28,9) scale the qty columns store. */
export function isWholeQuantity(quantity) {
    return Number.isFinite(quantity) && Number.isInteger(roundQuantity(quantity));
}
//# sourceMappingURL=is-whole-quantity.js.map